/* eslint-disable no-unused-vars */
import React, { useState, useEffect } from "react";
import { connect, useDispatch } from "react-redux";
import { goBack, push } from "connected-react-router";
import { bool, string, shape } from "prop-types";
import { Field, Form, Formik } from "formik";
import * as Yup from "yup";
import { Col, Row } from "react-bootstrap";
import * as i18n from "util/i18n";
import { actions as softTokenActions, selectors as softTokenSelectors } from "reducers/softToken";
import { actions as afipPaymentLinkActions, selectors as afipPaymentLinkSelectors } from "reducers/afipPaymentLink";
import Button from "pages/_components/Button";
import Checkbox from "pages/_components/Checkbox";
import GridTable from "pages/_components/GridTable/GridTable";
import { ResponsiveHeader } from "pages/_components/header";
import MainContainer from "pages/_components/MainContainer";
import Notification from "pages/_components/Notification";
import CustomData from "pages/_components/CustomData/CustomData";
import CustomText from "pages/_components/CustomText/CustomText";
import Credential from "pages/_components/fields/credentials/Credential";
import InfoTag from "pages/echeck/components/InfoTag";
import PaymentDueList from "../components/PaymentDueList";

const ServicesPaymentConfirm = (props) => {
    const { isDesktop, fetching, deviceStatus, servicePaymentData, cuitIsAdhered } = props;
    const [itemsToPay, setItemsToPay] = useState([]);
    const [accountLabel, setAccountLabel] = useState(null);
    const dispatch = useDispatch();

    useEffect(() => {
        if (servicePaymentData) {
            const { selectedServices, account, accountLabel } = servicePaymentData;
            setAccountLabel(
                accountLabel ||
                    `${i18n.get(`productType.${account?.type}`, "")} ····${account?.accountNumber?.slice(-4)} ${
                        account?.type
                    } ${i18n.get(`currency.label.${account?.currency}`, "")}` ||
                    "Error obteniendo la cuenta",
            );
            setItemsToPay(selectedServices);
        }
    }, [servicePaymentData]);

    const onBack = () => {
        dispatch(afipPaymentLinkActions.cleanPaymentData());
        if (servicePaymentData && servicePaymentData.selectedCuit) {
            dispatch(afipPaymentLinkActions.cleanDebt());
            dispatch(afipPaymentLinkActions.cleanHasSearchCuitFlag());
            dispatch(push("/arcaServices/newPayment"));
        } else {
            dispatch(goBack());
        }
    };

    const submit = (values) => {
        if (values) {
            const { selectedServices, account, totalAmount, cuit, idTransaction } = servicePaymentData;
            const params = {
                servicesList: selectedServices,
                accountId: account?.id,
                amount: {
                    quantity: totalAmount,
                    currency: "ARS",
                },
                _otp: values.credential,
                accountLabel,
                cuit,
                cuitIsAdhered: cuit && cuitIsAdhered,
                idTransaction,
            };
            dispatch(afipPaymentLinkActions.processServicesPayment(params));
        }
    };

    const getItemPosition = (pos) => {
        if (servicePaymentData && servicePaymentData.selectedCuit === null) {
            return pos - 1;
        }
        return pos;
    };

    return (
        <>
            <Notification scopeToShow="ServicesPaymentConfirmPage" />
            <ResponsiveHeader
                id="afip.newPayment.title"
                defaultTitle="Nuevo pago de servicios ARCA"
                onClickBack={onBack}
            />
            <MainContainer className="discounts-echeq-review">
                <CustomText
                    text={i18n.get("vep.payment.data.review.title", "Confirmá la transacción")}
                    textType="TEXT"
                    className="discounts-echeq-review__date-control"
                    defa
                />
                <GridTable className="deposits-details-list details">
                    <GridTable.Container columns={1} rows={1}>
                        <GridTable.Data columnStart={1} rowStart={1}>
                            <CustomData
                                titleText={i18n.get("vep.payment.data.debit.account", "Cuenta débito")}
                                titleClass="text-Primary-primary-color"
                                valueText={accountLabel}
                            />
                        </GridTable.Data>
                        {servicePaymentData?.cuit && (
                            <GridTable.Data columnStart={isDesktop ? 2 : 1} rowStart={isDesktop ? 1 : 2}>
                                <div>
                                    <CustomData
                                        titleText={i18n.get("services.payment.cuit", "CUIT/CUIL")}
                                        titleClass="text-Primary-primary-color"
                                        valueText={servicePaymentData?.cuit}
                                    />
                                    {cuitIsAdhered && (
                                        <div className="afip-services-confirm-info-tag">
                                            <InfoTag
                                                type="info"
                                                message={i18n.get("service.payment.cuit.adhered", "Agendado")}
                                                tagBackground="success"
                                            />
                                        </div>
                                    )}
                                </div>
                            </GridTable.Data>
                        )}
                        <GridTable.Data
                            columnStart={isDesktop ? getItemPosition(3) : 1}
                            rowStart={isDesktop ? 1 : getItemPosition(3)}>
                            <CustomData
                                titleText={i18n.get("services.payment.total.amount", "Monto total")}
                                valueText={servicePaymentData?.totalAmount || 0}
                                valueTextType="ARS"
                            />
                        </GridTable.Data>
                        <GridTable.Data
                            // eslint-disable-next-line no-nested-ternary
                            columnStart={isDesktop ? (servicePaymentData?.selectedCuit ? 1 : 3) : 1}
                            rowStart={isDesktop ? getItemPosition(2) : getItemPosition(4)}>
                            <CustomData
                                titleText={i18n.get("services.payment.total.items", "Cantidad de pagos")}
                                valueText={itemsToPay?.length}
                            />
                        </GridTable.Data>
                    </GridTable.Container>
                </GridTable>
                {itemsToPay.length > 0 && (
                    <>
                        <PaymentDueList {...props} dataToList={itemsToPay} isConfirmPage />
                    </>
                )}

                <Formik
                    // ref={(el) => setFormRef(el)}
                    validateOnBlur
                    validateOnChange={false}
                    initialValues={{
                        credential: "",
                        termAndConditions: false,
                    }}
                    validationSchema={Yup.object().shape({
                        credential:
                            deviceStatus === "NO_DEVICE"
                                ? Yup.string().required(i18n.get("deposits.request.required"))
                                : Yup.string(),
                        // termAndConditions: Yup.bool()
                        //     .test(
                        //         "is-true",
                        //         i18n.get("forms.inputFile.massivePayments.invalid.required"),
                        //         (value) => !!value,
                        //     )
                        //     .required(i18n.get("forms.inputFile.massivePayments.invalid.required")),
                    })}
                    onSubmit={submit}>
                    {({ setFieldValue, values }) => (
                        <Form className="termsandconditions">
                            <div className="container py-8" />
                            <Row className="form-actions">
                                {/* <Col xs={12} md={12}>
                                    <div className="discounts-echeq-review__form-actions ml-8">
                                        <Field
                                            component={Checkbox}
                                            idForm="discounts.new.lastForm"
                                            name="termAndConditions"
                                            labelText="discounts.new.review.termAndConditions.label"
                                            labelTextProps={{ defaultValue: "Leé y aceptá los\u00A0" }}
                                        />
                                        <Button
                                            block
                                            className="btn btn-link discounts-echeq-review__form-actions-terms"
                                            onClick={() => {
                                                setFieldValue("termAndConditions", !values?.termAndConditions, false);
                                            }}
                                            defaultLabelText="Términos y Condiciones"
                                        />
                                    </div>
                                </Col> */}

                                {deviceStatus !== "NO_DEVICE" ? null : (
                                    <Col xs={12} md={4} mdOffset={2}>
                                        <Field
                                            idForm="form.credential"
                                            name="credential"
                                            labelText="form.credential.token.label"
                                            placeholderText="Ej: 120573"
                                            component={Credential}
                                            type="otp"
                                        />
                                    </Col>
                                )}

                                <Col xs={12} md={4} mdOffset={6}>
                                    <div className="form-group">
                                        <span className="data-label">
                                            <span> &nbsp;</span>
                                        </span>
                                        <div className="button-group">
                                            <Button
                                                block
                                                type="submit"
                                                label="global.send"
                                                bsStyle="primary"
                                                loading={fetching}
                                                disabled={!values.credential.length > 0}
                                                // disabled={!values.termAndConditions || !values.credential.length > 0}
                                            />
                                        </div>
                                    </div>
                                </Col>
                            </Row>
                        </Form>
                    )}
                </Formik>
            </MainContainer>
        </>
    );
};

ServicesPaymentConfirm.propTypes = {
    isDesktop: bool.isRequired,
    deviceStatus: string.isRequired,
    servicePaymentData: shape({}).isRequired,
    fetching: bool.isRequired,
    cuitIsAdhered: bool.isRequired,
    // tokenInfo: shape({}).isRequired,
};
const mapStateToProps = (state) => ({
    // tokenInfo: softTokenSelectors.getTokenInfo(state),
    deviceStatus: softTokenSelectors.getDeviceStatus(state),
    fetching: afipPaymentLinkSelectors.getFetching(state),
    servicePaymentData: afipPaymentLinkSelectors.getServicesPaymentData(state),
    cuitIsAdhered: afipPaymentLinkSelectors.getCuitIsAdhered(state),
});
export default connect(mapStateToProps)(ServicesPaymentConfirm);
